import { getConnectionPool } from "../../core/connectionPool";
import { uuid } from "../../utils/uuid";

export class Task {
    private id!: Long;
    public name: string = "";
    public progress: number;
    public current_size: number;
    public status: number = 0; // 0: running, 1: completed, 2: failed 3.cancelled
    public description: string = "";
    public total_size: number;
    constructor(
        total_size: number,
        name: string = "",
        description: string = "",
    ) {
        this.total_size = total_size;
        this.id = uuid();
        this.progress = 0;
        this.current_size = 0;
        this.name = name;
        this.description = description;
    }
    setStatus(status: number) {
        this.status = status;
    }
    getId(): Long {
        return this.id;
    }
    getName(): string {
        return this.name;
    }
    getDescription(): string {
        return this.description;
    }
    getProgress(): number {
        return this.progress;
    }
    getStatus(): number {
        return this.status;
    }
};


export class TaskManager {
    public runningTasks: Task[] = [];
    public completedTasks: Task[] = [];
    constructor() { }
    getRunningTasks(): Task[] {
        return this.runningTasks;
    }
    getCompletedTasks(): Task[] {
        return this.completedTasks;
    }
    addRunningTask(task: Task): void {
        this.runningTasks.push(task);
    }
    addCompletedTask(task: Task,status:number): void {
        this.completedTasks.push(task);
        // console.log("Task completed:", task.name, "Status:", status);
        const index = this.runningTasks.indexOf(task);
        if (index > -1) {
            task.status = status;
            this.runningTasks.splice(index, 1);
        }
        // console.log("Running tasks after completion:", this.runningTasks);
        // console.log("Completed tasks:", this.completedTasks);
    }
    cancelTask(id: Long,status:number) {
        let task =  this.runningTasks.find(t => t.getId() === id);
        task.setStatus(3);
    }
}

export const cancelRequest = async (taskId: Long): Promise<void> => {
    const pool = await getConnectionPool();
    pool.addCancellledRequest(taskId);
};